module.exports = "vUv=uv;"